import axios from '@/plugins/axios'

import { useAuthorizationStore } from '@/store/authorizationStore'

const getWorkspaceId = () => useAuthorizationStore().getWorkspaceSlug

const createRtbParameter = ({ slug, formData }) => axios.post(`${getWorkspaceId()}/campaigns/${slug}/rtb-settings/parameters`, formData)
const updateRtbParameter = ({ slug, formData, parameterId }) => axios.patch(`${getWorkspaceId()}/campaigns/${slug}/rtb-settings/parameters/${parameterId}`, formData)
const deleteRtbParameter = ({ slug, parameterId }) => axios.delete(`${getWorkspaceId()}/campaigns/${slug}/rtb-settings/parameters/${parameterId}`)

export {
    createRtbParameter,
    updateRtbParameter,
    deleteRtbParameter,
}
